import classes from './Headline.module.css'

const HeadLine = (props) => {
    return <h1 className={classes.headLine}>{props.children}</h1>
}

export default HeadLine